import React from 'react';

const LABEL_CONTAINER_STYLE = {
	display: 'inline-block',
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	verticalAlign: 'middle'
};

const SPLIT_INFO_STYLE = {
	color: 'green',
	fontWeight: 'bold',
	marginRight: '0.5rem',
	fontFamily: 'monospace'
};

/**
 * @name getSectionLabelNode
 * @description Returns a JSX node for section label with split info.
 */
export const getSectionLabelNode = (unit, splitInfo) => {
	const { name, videoSectionId } = unit;
	return (
		<span style={LABEL_CONTAINER_STYLE}>
			{splitInfo && <span style={SPLIT_INFO_STYLE}>{splitInfo}</span>}
			{`${name} (${videoSectionId})`}
		</span>
	);
};
